<template>
  <CreateLayout title="ویرایش برند" :submitFunction="updateBrand" />
</template>

<script>
import CreateLayout from "./CreateLayout";
import {mapActions} from "vuex";

export default {
  name: "EditBrand",
  components: {CreateLayout},
  methods:{
    ...mapActions({
      updateBrand: "Brand/updateBrand"
    })
  }
};
</script>

<style scoped>


</style>